<div class="row">
  <div class="col-md-12">
    <div class="six_box_heading">
      <h2>View courses by askIITians</h2>
    </div>
  </div>
  <div class="col-md-12">
    <div class="askiitians_course">
      <a (click)="viewCourses('one-to-one')">
        <span> 
        <img src="/assets/images/fourm-img/askiitians_course2.jpg" alt="askiitians_course" width="90px" height="66px"  loading="lazy"/> </span>
        <img src="/assets/images/fourm-img/askiitians_course2-2.jpg" alt="askiitians_course" width="110px" height="35px" loading="lazy" />
        <h3>Design classes One-on-One in your own way with Top IITians/Medical Professionals</h3>
        <span>Click Here Know More <i class="fa fa-long-arrow-right" aria-hidden="true"></i></span>
      </a>
      
        <a (click)="viewCourses('online-study-packages')"><span> <img src="/assets/images/fourm-img/askiitians_course3.jpg" width="90px" height="66px" loading="lazy" alt="askiitians_course" /> </span>
        <img src="/assets/images/fourm-img/askiitians_course3-3.jpg" loading="lazy" alt="askiitians_course" width="110px" height="35px"  />
        <h3>Complete Self Study Package designed by Industry Leading Experts</h3>
        <span>Click Here Know More <i aria-hidden="true" class="fa fa-long-arrow-right"></i></span></a>
      
        <a (click)="viewCourses('juniorhacker')"><span> <img src="/assets/images/fourm-img/askiitians_course4.jpg" alt="askiitians_course" loading="lazy" width="90px" height="66px"  /> </span>
        <img src="/assets/images/fourm-img/askiitians_course4-4.jpg" alt="askiitians_course" loading="lazy" width="110px" height="35px" />
        <h3>Live 1-1 coding classes to unleash the Creator in your Child</h3>
        <span>Click Here Know More <i aria-hidden="true" class="fa fa-long-arrow-right"></i></span></a>
      
        <a (click)="viewCourses('online-study-packages')"
        ><span> <img src="/assets/images/fourm-img/askiitians_course6.jpg" alt="askiitians_course" loading="lazy" width="90px" height="66px" /> </span>
        <img src="/assets/images/fourm-img/askiitians_course6-6.jpg" alt="askiitians_course" loading="lazy" width="110px" height="35px" />
        <h3>a Complete All-in-One Study package Fully Loaded inside a Tablet!</h3>
        <span>Click Here Know More <i aria-hidden="true" class="fa fa-long-arrow-right"></i></span>
        </a>
  </div>
</div>
